import { api } from "@/api/api";

export const Auth = {
    state: {
        isAuthenticated: false,
        accessToken: null,
        refreshToken: null,
        userProfile: null,
    },
    getters: {
        getIsAuthenticated(state) {
            return state.isAuthenticated;
        },
        getAccessToken(state) {
            return state.accessToken;
        },
        getRefreshToken(state) {
            return state.refreshToken;
        },
        getUserProfile(state) {
            return state.userProfile;
        },
    },
    mutations: {
        setAccessToken(state, payload) {
            state.accessToken = payload;
            sessionStorage.setItem("accessToken", payload);
        },

        setRefreshToken(state, payload) {
            state.refreshToken = payload;
            sessionStorage.setItem("refreshToken", payload);
        },

        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUserProfile(state, payload) {
            state.userProfile = payload;
        },
    },
    actions: {
        async signup(_, args) {
            await api.auth.signup(args)
            .catch((err) => {
                console.log(err)
                return Promise.reject(err.response.data.message);
            })
            return Promise.resolve();
        },

        async loginUser({ dispatch, commit }, user) {
            await api.auth
                .login(user)
                .then((res) => {
                    commit("setRefreshToken", res.data.refreshToken);
                    commit("setAccessToken", res.data.accessToken);
                    commit("setIsAuthenticated", true);
                    dispatch("getUserProfile");
                    return Promise.resolve(res);
                })
                .catch((err) => {
                    console.log("login fail : " + err);
                    commit("setIsAuthenticated", false);
                    return Promise.reject(err);
                });
        },

        async refreshAccessToken({ commit }) {
            try {
                const response = await api.auth.refreshAccessToken();
                commit("setAccessToken", response.data.accessToken);
                commit("setIsAuthenticated", true);
                return response.data.accessToken;
            } catch (err) {
                commit("setIsAuthenticated", false);
                throw err;
            }
        },

        async postAccess({ commit }) {
            await api.user
                .postAccess()
                .then((res) => {
                    if (res.data.userId != null) {
                        commit("setIsAuthenticated", true);
                    }
                    return Promise.resolve(res);
                })
                .catch((err) => {
                    console.log("login fail : " + err);
                    return Promise.reject(err);
                });
        },

        async findID(_, args) {
            try {
                const res = await api.auth.findID(args);
                return res.data;
            } catch (error) {
                return Promise.reject(error.response.data.message);
            }
        },

        async findPassword(_, args) {
            try {
                const res = await api.auth.findPassword(args);
                return Promise.resolve(res.data.message);
            } catch (error) {
                return Promise.reject(error.response.data.message);
            }
        },

        async resetPassword(_, args) {
            try {
                const res = await api.auth.resetPassword(args);
                return Promise.resolve(res);
            } catch (error) {
                return Promise.reject(error.response.data.message);
            }
        },

        async getUserProfile({ commit }) {
            try {
                const res = await api.auth.getUserProfile();
                console.log(res);
                commit("setUserProfile", res.data);
                commit("setIsAuthenticated", true);
                return res.data;
            } catch (error) {
                commit("setIsAuthenticated", false);
                return Promise.reject(error);
            }
        },

        logout({ commit }) {
            commit("setAccessToken", null);
            commit("setRefreshToken", null);
            commit("setIsAuthenticated", false);
        },
    },
};
